import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TokenService } from '@lib/core/token';
import { catchError, EMPTY, Observable, switchMap, take, throwError } from 'rxjs';

import { User } from '../model';
import { UserCardRepository } from '../user-card.repository';

export const MyCardResolve: ResolveFn<User> = (): Observable<User> => {
  const tokenService = inject(TokenService);
  const userRepository = inject(UserCardRepository);

  return tokenService.token$.pipe(
    take(1),
    switchMap((token) => (null !== token
      ? userRepository.getSelf()
      : throwError(() => 'token is not defined'))
    ),
    catchError(() => {
      tokenService.removeCredentials();

      return EMPTY;
    })
  );
};
